<style lang="scss">
  .no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    flex-grow: 1;
  }
</style>

<script>
  import ActivityIcon from "@sourcewhale/shared/svelte-design-system/components/atoms/ActivityIcon.svelte";
  import Avatar from "@sourcewhale/shared/svelte-design-system/components/atoms/Avatar.svelte";
  import Table from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/Table.svelte";
  import TBODY from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/TBODY.svelte";
  import TD from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/TD.svelte";
  import THEAD from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/THEAD.svelte";
  import TR from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/TR.svelte";
  import { activityFeedStore } from "../stores";
  import { formatActivityDate, formatActivityTime } from "../utils";
  import ActivityContent from "./ActivityContent.svelte";
  import NoActivityData from "./NoActivityData.svelte";

  export let data = [];
  export let selectedView = "pastActivity";
  // selectedView is used so we know what empty message to display, and to know
  // whether to show timestamps or not (scheduled activity should not show times)

  const { meta } = activityFeedStore;
  $: skeleton = $meta.fetching || !$meta.firstFetchDone;
  $: rowsData = skeleton
    ? Array.from({ length: 5 }).map(() => ({
        activityCode: "email",
        name: "Loading Activity Feed...",
        user: { picture: "", name: "?" },
        timestamp: 1,
      }))
    : data;
  $: noData = !rowsData.length;
  $: showTimes = selectedView === "pastActivity";
</script>

<!-- Place scroll bar in table so that header remains fixed -->
<div style={noData ? "" : "overflow: auto;"}>
  <Table>
    <THEAD>
      <TR>
        <TD>Activity Type</TD>
        <TD>User</TD>
        {#if showTimes}
          <TD>Date</TD>
          <TD>Time</TD>
        {/if}
      </TR>
    </THEAD>
    <TBODY>
      {#each rowsData as rowData}
        {@const { user = {} } = rowData}
        <TR>
          <TD>
            {#if rowData.activityCode || rowData.noteType}
              <ActivityIcon
                size="medium"
                kind={rowData.activityCode || rowData.noteType}
                {skeleton}
              />
            {/if}
            {#if rowData.name}
              {@const reason = rowData.notInterestedReason?.title}
              {@const reasonParens = reason ? ` (${reason})` : ""}
              <h4 class:skeleton>
                {rowData.name}{reasonParens}
              </h4>
            {/if}
          </TD>
          <TD>
            {#if user.picture || user.name}
              {@const names = user.name?.split(" ") || []}
              {@const firstName = names[0] || ""}
              {@const lastName = names.at(-1) || ""}
              <Avatar
                size="medium"
                src={user.picture}
                {skeleton}
                {firstName}
                {lastName}
              />
            {/if}
          </TD>
          {#if showTimes}
            <TD>
              {#if rowData.timestamp}
                <span class:skeleton
                  >{formatActivityDate(rowData.timestamp)}</span
                >
              {/if}
            </TD>
            <TD>
              {#if rowData.timestamp}
                <span class:skeleton
                  >{formatActivityTime(rowData.timestamp)}</span
                >
              {/if}
            </TD>
          {/if}
        </TR>
        {#if rowData.content}
          <TR isChild={true}>
            <TD colspan={showTimes ? 4 : 2}>
              <ActivityContent activity={rowData} />
            </TD>
          </TR>
        {/if}
      {/each}
    </TBODY>
  </Table>
</div>
<!-- Append at the end here so it is vertically centred in the modal -->
{#if noData}
  <div class="no-data">
    <NoActivityData {selectedView} />
  </div>
{/if}
